import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {UserAccountModel} from '../entity/userAccount.model';
import {UserAccountSummaryConverter} from './userAccountSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class UserAccountConverter extends HttpModelConverter<UserAccountModel> {

    constructor(private summaryConverter: UserAccountSummaryConverter) {
        super();
    }

    protected createInstance(): UserAccountModel {
        return new UserAccountModel();
    }

    protected enrichObject(result: UserAccountModel, src: UserAccountModel) {
        result.summary = this.summaryConverter.convert(src.summary);
    }

}
